
import React from 'react';

const LoadingDots = () => {
  return (
    <div className="flex items-center space-x-2 p-2">
      <div className="w-3 h-3 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '0ms' }}></div>
      <div className="w-3 h-3 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '300ms' }}></div>
      <div className="w-3 h-3 bg-gray-400 rounded-full animate-pulse" style={{ animationDelay: '600ms' }}></div>
    </div>
  );
};

export default LoadingDots;